import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Card,
  Dialog,
  DialogSurface,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  DialogBody,
  Button,
  useRestoreFocusTarget,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";

import styles from "./EnviarPitazoCard.module.css";
import iconoEnviarUnPitazo from "../../../../../assets/images/dt-mood/iconos/enviar-un-pitazo.svg";
import { PitazoContext } from "../../../context";
import { ChangeAwardStatus } from "../../../store/award/AwardSlice";
import { ChangePuntosAcumulados } from "../../../store/puntos-acumulados/PuntosAcumuladosSlice";
import {
  showPitazoSuccessAlert,
  showPitazoWarningAlert,
} from "../../../utilities";
import PitazoStepper from "../pitazo-stepper/PitazoStepper";

const EnviarPitazoCard = (props) => {
  const [pitazoState, setPitazoState] = useState();
  const [open, setOpen] = useState(false);
  const restoreFocusTargetAttribute = useRestoreFocusTarget();
  const dispatch = useDispatch();

  useEffect(() => {
    setOpen(false);

    if (pitazoState && pitazoState.state === "award") {
      dispatch(ChangeAwardStatus(pitazoState.badge_id));
      dispatch(ChangePuntosAcumulados(false));
      setPitazoState();
    }

    if (pitazoState && pitazoState.state === "success") {
      showPitazoSuccessAlert(pitazoState.id);
      dispatch(ChangePuntosAcumulados(false));
      setPitazoState();
    }

    if (pitazoState && pitazoState.state === "warning") {
      showPitazoWarningAlert();
      setPitazoState();
    }
  }, [pitazoState]);

  return (
    <>
      <Card
        className={`w-100 align-items-center cursor-pointer border-0 p-0`}
        onClick={() => setOpen(true)}
      >
        <div
          className={`d-flex flex-row w-100 p-3 ${styles.pitazoBg} ${styles.br6}`}
        >
          <div className="w-100 d-flex">
            <img
              src={iconoEnviarUnPitazo}
              alt="iconoEnviarUnPitazo"
              className={`icon-card-dtmood align-self-center ${styles.icono}`}
            />
            <span className="ms-2 align-self-center text-color-headings">
              Buzón de Quejas
            </span>
          </div>
        </div>
      </Card>

      <Dialog
        open={open}
        onOpenChange={(event, data) => {
          setOpen(data.open);
        }}
        onDismiss={{ ...restoreFocusTargetAttribute }}
      >
        <DialogSurface className={`p-1 ${styles.pitazoBg}`}>
          {open && (
            <>
              <DialogBody className={`${styles.dialogBody}`}>
                <div className={`p-3 ${styles.titleDiv}`}>
                  <DialogTitle
                    action={
                      <DialogTrigger action="close">
                        <Button
                          appearance="subtle"
                          aria-label="close"
                          icon={<Dismiss24Regular />}
                        />
                      </DialogTrigger>
                    }
                  >
                    <img
                      src={iconoEnviarUnPitazo}
                      alt="icono-contact-point"
                      className={`align-self-center me-2 pt-2 ${styles.icono}`}
                    />
                    <span className="text-color-headings font-medium">
                      Buzón de quejas
                    </span>
                  </DialogTitle>
                </div>

                <DialogContent className={`p-3 mt-1 ${styles.dialogContent}`}>
                  <PitazoContext.Provider value={{ setPitazoState }}>
                    <PitazoStepper />
                  </PitazoContext.Provider>
                </DialogContent>
              </DialogBody>
            </>
          )}
        </DialogSurface>
      </Dialog>
    </>
  );
};

export default EnviarPitazoCard;
